import DialogGuide from 'global/guides/Dialog'
import { useMutation } from 'react-query'
import { useNavigate, useParams } from 'react-router-dom'
import { escalas } from 'service/api/endpoints/escalas'
import { ID } from 'service/api/types'
import { toast } from 'sonner'

function ExcluirAssociacao() {
    const navigate = useNavigate()
    const { pivot, id } = useParams()

    const queryKey = ['escalas', id, 'funcionarios', pivot, 'excluir'] as const

    const { isLoading, mutate } = useMutation(queryKey, exluirAssociacao)

    const handleSubmit = () => {
        mutate(
            { id: id!, pivot: pivot! },
            {
                onSuccess: async () => {
                    await escalas.invalidateQueries({ id: id! })

                    toast.success('Escala excluída com sucesso')

                    navigate(-1)
                },
                onError: (err: any) => {
                    toast.error(err.message)
                },
            },
        )
    }

    return (
        <DialogGuide.Root
            width="auto"
            height="auto"
            onSubmit={handleSubmit}
            loading={isLoading}
        >
            <DialogGuide.Content>
                Realmente deseja excluir a escala do funcionário?
            </DialogGuide.Content>
            <DialogGuide.Actions>
                <DialogGuide.Actions.SecondaryButton />
                <DialogGuide.Actions.PrimaryButton color="error">
                    Excluir
                </DialogGuide.Actions.PrimaryButton>
            </DialogGuide.Actions>
        </DialogGuide.Root>
    )
}

function exluirAssociacao(props: { id: ID; pivot: string }) {
    return escalas.delete(props.id, `funcionarios/${props.pivot}`)
}

export default ExcluirAssociacao
